// Models
PJQ.models.rfi.RFI = PJQ.models.BaseModel.extend({
	notifyName: 'RFI',
	idAttribute: "rfiId",
	endpoint: function (urlOptions) {
		let arr;
		if (this.isNew()) {
			arr = [
				{
					endpoint: 'projects',
					value: this.get('projectId')
				},
				{
					endpoint: 'rfi',
					value: this.id
				}
			];
		}
		else {
			arr = [
				{
					endpoint: 'rfi',
					value: this.id
				}
			];
		}
		let params = [];
		if (urlOptions != null) {
			if (urlOptions.noNotify) {
				params.push({
					parameter: 'noNotify',
					value: true
				});
			}

			if (urlOptions.draft === true) {
				params.push({
					parameter: 'draft',
					value: true
				});
			}
		}

		return PJQ.helpers.urlHelpers.generateEndpoint(arr, params);
	},
	parse: function (model) {
		if (!model)
			return model;

		this.groups = new PJQ.collections.groups.Groups(model.groups);

		if (model.createdBy != null) {
			this.createdBy = new PJQ.models.projectContacts.ProjectContact(model.createdBy);
		}
		else {
			this.createdBy = null;
		}

		if (model.requestedBy != null) {
			this.requestedBy = new PJQ.models.projectContacts.ProjectContact(model.requestedBy);
		}
		else {
			this.requestedBy = null;
		}

		this.assigneeList = new PJQ.collections.projectContacts.ProjectContacts(model.assigneeList);

		this.distributionList = new PJQ.collections.projectContacts.ProjectContacts(model.distributionList);

		this.ballInCourt = new PJQ.collections.projectContacts.ProjectContacts(model.ballInCourt);

		this.responses = new PJQ.collections.rfi.Responses(model.responses);

		this.attachments = new PJQ.collections.rfi.Attachments(model.attachments);

		if (model.customFieldValues == null) {
			model.customFieldValues = [];
		}

		return model;
	},
	fetchNotifications: function (callback) {
		if (this.notifications == null) {
			this.notifications = new PJQ.collections.rfi.Notifications(null, {
				rfi: this
			})
		}

		this.notifications.fetch({
			success: _.bind(function () {
				callback(this.notifications);
			}, this)
		});
	},
	getStatusColor: function () {
		if (this.get('status') == null) {
			this.set('status', PJQ.constants.rfi.statuses.DRAFT);
		}
		return PJQ.constants.rfi.statusColors[this.get('status')];
	},
	getStatusName: function () {
		if (this.get('status') == null) {
			this.set('status', PJQ.constants.rfi.statuses.DRAFT);
		}
		return PJQ.constants.rfi.statusNames[this.get('status')];
	},
	checkIsAssignee: function (user) {
		return user && (this.get('isAssignee') || this.assigneeList.get(user.id) != null);
	},
	checkIsDistribution: function (user) {
		return user && (this.get('isDistribution') || this.distributionList.get(user.id) != null);
	},
	beforeSave: function () {
		this.set('assigneeList', this.assigneeList.toJSON());
		this.set('distributionList', this.distributionList.toJSON());
		this.set('ballInCourt', this.ballInCourt.toJSON());
		this.set('requestedBy', this.requestedBy);
		this.set('groups', this.groups.toJSON());
		this.set('attachments', this.attachments.getChangedModels());
		if (this.isNew()) {
			this.set('responses', this.responses.getChangedModels());
		}
	},
	open: function (callback, noNotify = false) {
		this.save({
			status: PJQ.constants.rfi.statuses.OPEN,
		}, {
			urlOptions: {
				noNotify: noNotify
			},
			success: function () {
				callback(true);
				PJQ.notifications.notify.successNotify({
					message: 'RFI opened'
				});
			},
			error: function () {
				callback(true);
			}
		});
	},
	close: function (callback, noNotify = false) {
		this.save({
			status: PJQ.constants.rfi.statuses.CLOSED,
		}, {
			urlOptions: {
				noNotify: noNotify
			},
			success: function () {
				callback(true);
				PJQ.notifications.notify.successNotify({
					message: 'RFI closed'
				});
			},
			error: function () {
				callback(true);
			}
		});
	}
});

PJQ.models.rfi.Settings = PJQ.models.BaseModel.extend({
	idAttribute: 'settingId',
	defaults: {
		type: 'RFI'
	},
	endpoint: function () {
		let project = this.get('project');
		if (project != null && project.id > 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: project.id
				},
				{
					endpoint: 'rfi'
				},
				{
					endpoint: 'settings'
				}
			])
		}
		else {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'users'
				},
				{
					endpoint: 'rfi'
				},
				{
					endpoint: 'settings'
				}
			])
		}
	}
});

PJQ.models.rfi.UserSettings = PJQ.models.BaseModel.extend({
	endpoint: function () {
		let params = [];
		if (this.options.forCompany) {
			params.push({
				parameter: 'forCompany',
				value: true
			});
		}
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'rfi'
			},
			{
				endpoint: 'settings'
			},
			{
				endpoint: 'user'
			}
		], params);
	},
	getSettings: function (view) {
		return _.find(this.attributes.viewSettings, _.bind(function (setting) {
			return setting.view === view;
		}, this));
	}
});

PJQ.models.rfi.Notification = PJQ.models.notifications.Notification.extend({
	notificationTypeNames: PJQ.constants.rfi.notificationTypeNames,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'rfi',
				value: this.collection.options.rfi.id
			},
			{
				endpoint: 'notifications',
				value: this.id
			}
		])
	}
});

PJQ.models.rfi.Attachment = PJQ.models.files.File.extend({
	idAttribute: 'attachmentId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'rfi',
				value: this.get('rfiId')
			},
			{
				endpoint: 'attachments',
				value: this.id
			}
		]);
	}
});

PJQ.models.rfi.CustomField = PJQ.models.customFields.CustomField.extend({
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'rfi'
			},
			{
				endpoint: 'customFields',
				value: this.id
			}
		])
	}
});

PJQ.models.rfi.Response = PJQ.models.BaseModel.extend({
	idAttribute: "responseId",
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'rfi',
				value: this.get('rfiId')
			},
			{
				endpoint: 'responses',
				value: this.id
			}
		])
	},
	parse: function (model) {
		if (!model) {
			return model;
		}

		if (model.createdBy != null) {
			this.createdBy = new PJQ.models.projectContacts.ProjectContact(model.createdBy);
		}

		return model;
	},
	accept: function (isAccepted, callback) {
		this.set();
		this.save({
			isAccepted: isAccepted
		}, {
			success: function () {
				callback(true);
				let message;
				if (isAccepted) {
					message = 'Response marked as accepted';
				}
				else {
					message = 'Response marked as not accepted';
				}
				PJQ.notifications.notify.successNotify({
					message: message
				});
			},
			error: function () {
				callback(false);
			}
		});
	}
});


// Collections
PJQ.collections.rfi = {};
PJQ.collections.rfi.RFIS = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.rfi.RFI,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'projects',
				value: this.options.project.id
			},
			{
				endpoint: 'rfi'
			}
		])
	}
});

PJQ.collections.rfi.Notifications = PJQ.collections.notifications.Notifications.extend({
	model: PJQ.models.rfi.Notification,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'rfi',
				value: this.options.rfi.id
			},
			{
				endpoint: 'notifications'
			}
		])
	}
});

PJQ.collections.rfi.Attachments = PJQ.collections.files.Files.extend({
	model: PJQ.models.rfi.Attachment,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'rfi',
				value: this.options.rfiId
			},
			{
				endpoint: 'attachments'
			}
		]);
	}
});

PJQ.collections.rfi.CustomFields = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.rfi.CustomField,
	options: {
		masterUserId: null
	},
	endpoint: function () {
		let projectId = null;
		if(this.options.project != null){
			projectId = this.options.project.id
		} else if(this.options.projectId > 0){
			projectId = this.options.projectId;
		}

		if(projectId > 0){
			return PJQ.helpers.urlHelpers.generateEndpoint([
					{
						endpoint: 'projects',
						value: projectId
					},
					{
						endpoint: 'rfi'
					},
					{
						endpoint: 'customFields'
					}
				],
				[
					{
						parameter: 'masterUserId',
						value: this.options.masterUserId > 0 ? this.options.masterUserId : PJQ.app.session.get('masterUserId')
					}
				]);
		}

		return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'rfi'
				},
				{
					endpoint: 'customFields'
				}
			],
			[
				{
					parameter: 'masterUserId',
					value: this.options.masterUserId > 0 ? this.options.masterUserId : PJQ.app.session.get('masterUserId')
				}
			]);
	}
});

PJQ.collections.rfi.Responses = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.rfi.Response,
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'rfi',
				value: this.options.rfiId
			},
			{
				endpoint: 'responses'
			}
		]);
	}
});
